import { render, staticRenderFns } from "./_bankProfile.vue?vue&type=template&id=3df580fb&scoped=true&lang=pug&"
import script from "./_bankProfile.vue?vue&type=script&lang=js&"
export * from "./_bankProfile.vue?vue&type=script&lang=js&"
import style0 from "./_bankProfile.vue?vue&type=style&index=0&id=3df580fb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3df580fb",
  null
  
)

export default component.exports